import { render, staticRenderFns } from "./DiagnosticSummaryDetail.vue?vue&type=template&id=4625b1f7&"
import script from "./DiagnosticSummaryDetail.vue?vue&type=script&lang=js&"
export * from "./DiagnosticSummaryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports